import * as yup from "yup";

const selecUserSchema = yup.object().shape({
	maa006Efa004Id: yup.string().nullable(),
	maa006Efa005Id: yup.string().nullable()
});

const addAndChangeSchemaAnalysis = (translate: Function) => yup.object().shape({
	maa001Titulo: yup.string().required(translate("Título é requerido")).max(200, translate("Título deve conter no máximo 200 caracteres")),
	maa001Descricao: yup.string().required(translate("Descrição é requerida")),
	maa001Label1: yup.string().required(translate("Label 1 é requerida")),
	maa001Label2: yup.string().required(translate("Label 2 é requerida")),
	maa001Label3: yup.string().required(translate("Label 3 é requerida")),
	matba006: yup.array().required(translate("Adicione ao menos uma permissão")).of(selecUserSchema.required("Necessário informar Campo"))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.maa006Efa005Id, (a: any) => !a.maa006Efa004Id)
		.unique(translate("Grupo de Usuários não podem ser repetidos"), (a: any) => a.maa006Efa004Id, (a: any) => !a.maa006Efa005Id)
});

const addAndChangeSchemaAnalysisModel = (translate: Function) => yup.object().shape({
	maa001Titulo: yup.string().required(translate("Título é requerido")).max(200, translate("Título deve conter no máximo 200 caracteres")),
	maa001Descricao: yup.string().required(translate("Descrição é requerida")),
	matba006: yup.array().required(translate("Adicione ao menos uma permissão")).of(selecUserSchema.required("Necessário informar Campo"))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.maa006Efa005Id, (a: any) => !a.maa006Efa004Id)
		.unique(translate("Grupo de Usuários não podem ser repetidos"), (a: any) => a.maa006Efa004Id, (a: any) => !a.maa006Efa005Id)
});

const deleteSchemaAnalysis = (translate: Function) => yup.object().shape({
	maa001Titulo: yup.string().required(translate("Título da análise não confere")).oneOf([yup.ref("maa001TituloConfirmation")], translate("Título da análise não confere"))
});

export const schemaNivel1 = (translate: Function) => yup.object().shape({
	maa002Descricao: yup.string().required(translate("Descrição é requerida")),
	maa002Explicacao: yup.string()
});

export const schemaNivel2 = (translate: Function) => yup.object().shape({
	maa003Descricao: yup.string().required(translate("Descrição é requerida")),
	maa003Explicacao: yup.string()
});

export const schemaNivel3 = (translate: Function) => yup.object().shape({
	maa004Descricao: yup.string().required(translate("Descrição é requerida"))
});

export const schemaAddItemSwot = (translate: Function) => yup.object().shape({
	mes001Id: yup.number().required(translate("Swot é requerida")),
	taa011Id: yup.number().required(translate("Dimensão padrão é requerida")).min(0),
	maa004Descricao: yup.string().required(translate("Item da Swot é requerido"))
});



export { addAndChangeSchemaAnalysis, addAndChangeSchemaAnalysisModel, deleteSchemaAnalysis };
